import React from "react";

import Svg, { Path, Circle } from "components/Svg";

const More = props => (
	<Svg
		width={17 * props.scale}
		height={17 * props.scale}
		viewBox="0 0 103 103"
		fill="none"
	>
        <Circle r="47.5" transform="matrix(-1 0 0 1 51.5 51.5)" stroke="white" stroke-width="8"/>
        <Circle cx="24.5" cy="52.5" r="6.5" fill="white"/>
        <Circle cx="43.5" cy="52.5" r="6.5" fill="white"/>
        <Circle cx="62.5" cy="52.5" r="6.5" fill="white"/>
		<Path
			fill={props.fill || "white"}
			d="M86 52.5L75.5 58.1292V46.8708L86 52.5Z"
		/>
	</Svg>

);

export default More;



// WEBPACK FOOTER //
// ./src/components/svgs/More/index.js